import { createSlice } from "@reduxjs/toolkit";

export const image = createSlice({
    name: "img",
    initialState: {
        dataImg: []
    },
    reducers: {
        storeDataImg: (state, action) => {
            state.dataImg = action.payload;
        },
    },
});

export const {
    storeDataImg
} = image.actions;

export default image.reducer;